export const AUTH_CONFIG = {
  domain: 'conexon.auth0.com',
  clientId: 'FEti2RNBamNHJ2F2Nb4aDDaPT7ojuDTV',
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACKURL
}
